<template>
    <div class="wrapper default">
        <div class="container">
                <component :is="componentName" 
                           @redirectToConfirm="redirectToConfirm($event)"
                           @redirectToChangePassword="redirectToChangePassword($event)"
                           @redirectToComplete="redirectToComplete($event)"></component>
        </div>
        <mini-footer></mini-footer>
    </div>

</template>

<script>
 
    import miniFooter from "../../sharedComponents/footerComponents/miniFooter.vue";
    import { initialSite } from "../../../module/initialSite"
    import request from './request.vue';
    import confirm from './confirm.vue';
    import changePassword from "./changePassword.vue";
    import completed from './completed.vue'
    export default {
        data() {
            return {
                componentName: 'request',
            }
        },
        components: {
            'mini-footer': miniFooter,
            'request': request,
            'confirm': confirm, 
            'changePassword': changePassword, 
            'completed' : completed
        },
        methods: {
            redirectToConfirm(data) {
                this.$store.commit('setConfirm', data )
                this.componentName = 'confirm';
            }, 
            redirectToChangePassword(data) {
                this.componentName = 'changePassword';
            }, 
            redirectToComplete(data) {
                this.componentName = 'completed';
            }, 
        },
        beforeMount() {
            initialSite(this);
        },
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
                if (isUserLogined())
                    vm.$router.push('/');
            });
        },
    }
</script>

<style scoped>
</style>